// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609140434/js/" + chunkId + "." + {"44":"a9b44a21","225":"a63d2398","481":"21ffdc74","486":"8db7d8f8","770":"f7f74dde"}[chunkId] + ".0.009780081220072012.chunk.js";
};